import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Form, Input, Checkbox, DatePicker, Row, Col, notification } from 'antd';
import { CloseOutlined, SaveOutlined, StarFilled } from '@ant-design/icons';
import en from 'antd/es/date-picker/locale/en_US';
import dayjs from 'dayjs';
import buddhistEra from 'dayjs/plugin/buddhistEra';
import FormLabel from '../../../components/FormLabel';
import CustomSelect from '../../../components/CustomSelect';
import NormalFormLabel from '../../../components/NormalFormLabel';
import { getListCampaignsCMSNextRequest } from '../../../services/commonRequest';
import { useMutation, useQuery } from '@tanstack/react-query';
import { getListAudienceRequest } from '../../../services/audianceRequest';
import { createUpdateNotificationRequest } from '../../../services/notificationRequest';
import TextEditorCustom from '../../../components/TextEditorCustom';
import { CREATE_UPDATE_NOTIFICATION } from '../../../constants/apiEndPoint';
import { checkPermission } from '../../../utils/checkPermission';
import { LIST_CATEGORY_NOTIFICATION, LIST_STATUS_NOTIFICATION } from '../../../constants/appSelect';
const { TextArea } = Input;

dayjs.extend(buddhistEra);

const buddhistLocale = {
  ...en,
  lang: {
    ...en.lang,
    fieldDateFormat: 'DD-MM-YYYY',
    fieldDateTimeFormat: 'DD-MM-YYYY HH:mm',
    yearFormat: 'YYYY',
    cellYearFormat: 'YYYY',
  },
};

const url =
  'https://docs.google.com/spreadsheets/d/1Rj7vlAhIiSjU6Fx8hum3GzI8cxD6Mdw5sKeFgGqkxag/edit?gid=908194191openByDeeplink/FullContent#gid=908194191';

const ThemThongBao = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const watchCTAButton = Form.useWatch('cta_button', form);
  const watchType = Form.useWatch('type', form);
  const watchTypePublishTime = Form.useWatch('type_publish_time', form);



  const backToMenu = () => {
    navigate(-1);
  };

  // get list audience
  const { data: audienceList } = useQuery({
    queryKey: ['audienceList'],
    queryFn: () => getListAudienceRequest(),
  });

  // convert list audience options
  const dataAudienceOptions = useMemo(() => {
    const options =
      audienceList?.map((item) => {
        return { label: item?.name, value: item?.code };
      }) || [];
    return options;
  }, [audienceList]);



  // get data campaigns cms next
  const { data: dataAllCampaignsCMSNext } = useQuery({
    queryKey: ['dataAllCampaignsCMSNext'],
    queryFn: () => getListCampaignsCMSNextRequest(),
  });

  // convert list campaigns cms next options
  const dataAllCampaignsCMSNextOption = useMemo(() => {
    const options =
      dataAllCampaignsCMSNext
        ?.filter((item) => item?.status === 1)
        ?.map((item) => {
          return { label: item?.title, value: item?.id };
        }) || [];
    return options;
  }, [dataAllCampaignsCMSNext]);

  // handle submit form
  const { mutate: mutateCreateNotification, isPending: isLoadingCreateNotification } = useMutation({
    mutationFn: createUpdateNotificationRequest,
    onSuccess: async (data) => {
      if (data?.status) {
        notification.success({
          message: 'Thêm mới thông báo thành công',
        });
        navigate('/quan-ly-thong-bao');
      } else {
        notification.error({
          message: data?.showMessage || 'Có lỗi xảy ra vui lòng thử lại sau!',
        });
      }
    },
    onError: (error) => {
      notification.error({
        message: error.data?.showMessage || 'Có lỗi xảy ra vui lòng thử lại sau!',
      });
    },
  });

  const handleSubmitForm = (data) => {
    const dataSubmit = {
      id: null,
      //   option: data?.option, // gửi theo firebase hoặc onesignal
      mode_push: data?.mode_push, // thống kê push trên DSP
      type_topic: data?.type_topic, // loại tập khách hàng
      platform: null, // nền tảng
      version: null, // version
      topic: null, // topic
      audience: data?.audience, // tập khách hàng
      campaign_id: data?.campaign_id, // id chiến dịch ghi nhận order
      label: data?.label, // tên thông báo/label thống kê
      title: data?.title, // tiêu đề thông báo
      subtitle: data?.subtitle, // nội dung ngắn
      category_id: data?.category_id, // loại thông báo
      type: data?.type, // mở theo deep link/ mở theo nội dung chi tiết
      content: data?.type === 1 ? data?.content : null, // nội dung đầy đủ
      cta_button: data?.cta_button ? '1' : '0', // đặt thêm nút CTA vào phần nội dung thông báo
      cta_title: data?.type === 1 && data?.cta_button ? data?.cta_title : null, // title của nút
      cta_link: data?.type === 1 && data?.cta_button ? data?.cta_link : null, // deeplink của nút
      deeplink: data?.type === 2 ? data?.deeplink : null, // deeplink

      public_time: data?.type_publish_time === 2 ? dayjs(data?.public_time).unix() : dayjs().unix(), // thời gian gửi thông báo
      status: data?.status, // trạng thái
    };
    mutateCreateNotification(dataSubmit);
  };

  return (
    <>
      {checkPermission(CREATE_UPDATE_NOTIFICATION, 'Tạo mới') && (
        <div className="w-full">
          <h1 className="font-semibold text-[24px] leading-[32px] gap-[10px] py-[10px]">Thêm mới thông báo</h1>

          <Form
            name="create-notification"
            form={form}
            layout="vertical"
            onFinish={handleSubmitForm}
            requiredMark={false}
            scrollToFirstError={{ behavior: 'smooth', block: 'center', focus: true }}
          >
            <Row gutter={[16, 0]}>
              {/* <Col xs={12}>
                <Form.Item
                  label={<FormLabel text="Gửi theo Firebase hoặc OneSignal" />}
                  name="option"
                  rules={[{ required: true, message: 'Vui lòng chọn một phương thức gửi' }]}
                >
                  <CustomSelect
                    placeholder="Chọn phương thức gửi"
                    options={[
                      { value: 1, label: 'Firebase' },
                      { value: 2, label: 'OneSignal' },
                    ]}
                  />
                </Form.Item>
              </Col> */}

              <Col xs={12}>
                <Form.Item
                  label={<FormLabel text="Thống kê push trên DSP" />}
                  rules={[{ required: true, message: 'Vui lòng chọn thống kê push trên DSP' }]}
                  name="mode_push"
                  initialValue={1}
                >
                  <CustomSelect
                    placeholder="Chọn thống kê push trên DSP"
                    options={[
                      { value: 0, label: 'Không (push bằng topic)' },
                      { value: 1, label: 'Có (push bằng device)' },
                    ]}
                  />
                </Form.Item>
              </Col>

              {/* <Col xs={12}>
                <Form.Item
                  label={<FormLabel text="Loại tập khách hàng" />}
                  name="type_topic"
                  rules={[{ required: true, message: 'Vui lòng chọn loại tập khách hàng' }]}
                  initialValue={1}
                >
                  <CustomSelect
                    placeholder="Chọn loại tập khách hàng"
                    allowClear
                    options={[
                      { value: 1, label: 'Topic' },
                      { value: 2, label: 'Tập khách hàng' },
                    ]}
                  />
                </Form.Item>
              </Col>

              {watchTypeTopicValue === 1 && (
                <> */}

              {/* </>
              )}

              {watchTypeTopicValue === 2 && ( */}
              <Col xs={12}>
                <Form.Item label={<NormalFormLabel text="Tập khách hàng" />} name="audience">
                  <CustomSelect
                    placeholder="Chọn tập khách hàng"
                    allowClear
                    mode="multiple"
                    options={dataAudienceOptions}
                  />
                </Form.Item>
              </Col>
              {/* )} */}

              <Col xs={24}>
                <Form.Item
                  label={<FormLabel text="Chiến dịch ghi nhận order" />}
                  name="campaign_id"
                  rules={[{ required: true, message: 'Vui lòng chọn chiến dịch ghi nhận order' }]}
                >
                  <CustomSelect
                    placeholder="Chọn chiến dịch ghi nhận order"
                    allowClear
                    options={dataAllCampaignsCMSNextOption}
                  />
                </Form.Item>
              </Col>

              <Col xs={24}>
                <Form.Item
                  label={
                    <div className="flex items-center">
                      <span className="font-roboto text-[14px] font-medium leading-5 tracking-[0.005em]">
                        Tên thông báo/label thống kê
                      </span>
                      <StarFilled className="letter-spacing-1 text-[5px] ml-1 text-red-700" />
                      <p>“Viết liền & viết thường & không dấu & không ký tự đặc biệt. VD: thongbao_uudai”</p>
                    </div>
                  }
                  rules={[
                    { required: true, message: 'Vui lòng nhập tên thông báo/label thống kê' },
                    { pattern: /^[a-z0-9_]+$/, message: 'Chỉ được nhập chữ thường, không số và không ký tự đặc biệt' },
                  ]}
                  name="label"
                >
                  <Input placeholder="Nhập tên thông báo/label thống kê" />
                </Form.Item>
              </Col>

              <Col xs={24}>
                <Form.Item
                  label={<FormLabel text="Tiêu đề" />}
                  rules={[{ required: true, message: 'Vui lòng nhập tiêu đề thông báo' }]}
                  name="title"
                >
                  <Input placeholder="Nhập tiêu đề thông báo" />
                </Form.Item>
              </Col>

              <Col xs={24}>
                <Form.Item
                  label={<FormLabel text="Nội dung ngắn gọn" />}
                  rules={[{ required: true, message: 'Vui liệu nhập nội dung ngắn gọn' }]}
                  name="subtitle"
                >
                  <TextArea rows={4} placeholder="Nhập nội dung ngắn gọn...." style={{ width: '100%' }} />
                </Form.Item>
              </Col>

              <Col xs={12}>
                <Form.Item
                  label={<FormLabel text="Loại thông báo" />}
                  rules={[{ required: true, message: 'Vui liệu chọn loại thông báo' }]}
                  name="category_id"
                  initialValue={1}
                >
                  <CustomSelect placeholder="Chọn loại thông báo" options={LIST_CATEGORY_NOTIFICATION} />
                </Form.Item>
              </Col>
              <Col xs={12}>
                <Form.Item
                  label={<FormLabel text="Mở theo deeplink/ Mở theo nội dung chi tiết" />}
                  rules={[{ required: true, message: 'Vui lòng chọn một phương thức mở' }]}
                  name="type"
                  initialValue={2}
                >
                  <CustomSelect
                    placeholder="Chọn phương thức mở"
                    options={[
                      { value: 1, label: 'Mở theo nội dung chi tiết' },
                      { value: 2, label: 'Mở theo deeplink' },
                    ]}
                  />
                </Form.Item>
              </Col>

              {watchType === 1 && (
                <>
                  <Col xs={24}>
                    <Form.Item
                      label={<FormLabel text="Nội dung đầy đủ" />}
                      rules={[{ required: true, message: 'Vui lòng nhập nội dung đầy đủ' }]}
                      name="content"
                      valuePropName="value"
                      getValueFromEvent={(content) => content}
                    >
                      <TextEditorCustom />
                    </Form.Item>
                  </Col>
                  <Col xs={24}>
                    <Form.Item valuePropName="checked" name="cta_button">
                      <Checkbox className="font-bold " checked>
                        <p className="font-medium text-[14px] leading-[20px]">
                          Đặt thêm nút CTA vào phần nội dung thông báo
                        </p>
                      </Checkbox>
                    </Form.Item>
                  </Col>
                  {watchCTAButton && (
                    <Col xs={24}>
                      <div className="relative mb-4" style={{ border: '1px dashed red', padding: '16px' }}>
                        <Row gutter={[16, 0]}>
                          <Col xs={12}>
                            <Form.Item
                              label={<FormLabel text="Title của nút" />}
                              rules={[{ required: watchCTAButton, message: 'Vui lòng nhập title của nút' }]}
                              name="cta_title"
                            >
                              <Input placeholder="Nhập title của nút..." />
                            </Form.Item>
                          </Col>
                          <Col xs={12}>
                            <Form.Item
                              label={<FormLabel text="Deeplink của nút" />}
                              rules={[{ required: watchCTAButton, message: 'Vui lòng nhập deeplink của nút' }]}
                              name="cta_link"
                            >
                              <Input placeholder="Nhập deeplink của nút..." />
                            </Form.Item>
                          </Col>
                        </Row>
                      </div>
                    </Col>
                  )}
                </>
              )}

              {watchType === 2 && (
                <Col xs={24}>
                  <Form.Item
                    label={
                      <div className="flex items-center">
                        <span className="font-roboto text-[14px] font-medium leading-5 tracking-[0.005em]">
                          Deeplink
                        </span>
                        <StarFilled className="letter-spacing-1 text-[5px] ml-1 text-red-700" />
                        <p className="ml-5">
                          Format theo file{' '}
                          <a href={url} className="text-blue-700">
                            Lịch Việt - DeepLink
                          </a>
                        </p>
                      </div>
                    }
                    rules={[{ required: true, message: 'Vui lòng nhập deeplink' }]}
                    name="deeplink"
                  >
                    <Input placeholder="Nhập deeplink..." />
                  </Form.Item>
                </Col>
              )}

              <Col xs={24}>
                <Form.Item
                  label={<FormLabel text="Thời gian gửi" />}
                  rules={[{ required: true, message: 'Vui lòng chọn thời gian gửi' }]}
                  name="type_publish_time"
                >
                  <CustomSelect
                    placeholder="Chọn thời gian gửi"
                    options={[
                      { value: 1, label: 'Ngay bây giờ' },
                      { value: 2, label: 'Thiết lập thời gian gửi' },
                    ]}
                  />
                </Form.Item>
              </Col>
              {watchTypePublishTime === 2 && (
                <Col xs={24}>
                  <Form.Item
                    label={<FormLabel text="Thời gian gửi thông báo" />}
                    rules={[
                      { required: watchTypePublishTime === 2, message: 'Vui lòng chọn thời gian gửi thông báo' },
                      {
                        validator: (_, value) => {
                          if (value && dayjs(value).isBefore(dayjs())) {
                            return Promise.reject(new Error('Thời gian gửi phải là thời gian trong tương lai'));
                          }
                          return Promise.resolve();
                        },
                      },
                    ]}
                    name="public_time"
                  >
                    <DatePicker
                      format="DD/MM/YYYY HH:mm:ss"
                      placeholder="Chọn thời gian gửi thông báo"
                      showTime
                      disabledDate={(current) => current && current < dayjs().startOf('day')}
                      locale={buddhistLocale}
                      style={{ width: '100%', height: '40px' }}
                    />
                  </Form.Item>
                </Col>
              )}
              <Col xs={24}>
                <Form.Item
                  label={<FormLabel text="Trạng thái" />}
                  rules={[{ required: true, message: 'Vui liệu chọn trạng thái' }]}
                  name="status"
                >
                  <CustomSelect
                    placeholder="Chọn trạng thái"
                    options={[LIST_STATUS_NOTIFICATION[0], LIST_STATUS_NOTIFICATION[1]]}
                  />
                </Form.Item>
              </Col>
              <Col xs={24}>
                <div className="flex justify-end gap-3">
                  <Form.Item>
                    <Button onClick={backToMenu}>
                      <CloseOutlined /> Hủy bỏ
                    </Button>
                  </Form.Item>
                  <Form.Item>
                    <Button loading={isLoadingCreateNotification} type="primary" htmlType="submit">
                      <SaveOutlined /> Lưu lại
                    </Button>
                  </Form.Item>
                </div>
              </Col>
            </Row>
          </Form>
        </div>
      )}
    </>
  );
};

export default ThemThongBao;
